import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxSpinnerModule } from "ngx-spinner";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ModalModule } from './components/modal';

import { ClientTokenInterceptor } from './interceptors/client-token.interceptor';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { SanitiseHtmlPipe } from './pipes/sanitise-html.pipe';
import { FourOhFourModule } from './404/four-oh-four.module';

// full calendar
// import { FullCalendarModule } from '@fullcalendar/angular';
// import dayGridPlugin from '@fullcalendar/daygrid'; // plugin
// import interactionPlugin from '@fullcalendar/interaction'; // plugin
import { OnlineStatusModule } from 'ngx-online-status';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ArrivalStatusComponent } from './tabs/customizable-tabs/arrival-status/arrival-status.component';
import { LoginComponent } from './tabs/login/login/login.component';
import { NoBookingComponent } from './tabs/custom-tabs/no-booking/no-booking.component';
import { MemberBarComponent } from './components/member-bar/member-bar.component';

import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { FormBuilderComponent } from './components/form-builder/form-builder.component';

import { MsalModule, MsalRedirectComponent, MsalGuard, MsalInterceptor } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

let ssoClientId = '';
let ssoAuthorityId = '';
let ssoRedirectUri = '';

const host = window.location.host;
const pathname = window.location.pathname;
var split = pathname.split("/");
var company = split[2];
var companyName = split[1];
const sso = environment.sso as any;
try {
  ssoRedirectUri = sso[companyName].redirect as string;
  ssoClientId = sso[companyName].clientId as string;
  ssoAuthorityId = sso[companyName].authority as string;

  console.log('ssoRedirectUri', ssoRedirectUri);
}
catch (err) {
  console.warn(`Could not find EntraID credentials for ${companyName} in app environment.`);
}

// FullCalendarModule.registerPlugins([ // register plugin(s)
//   dayGridPlugin,
//   interactionPlugin
// ]);

// required for AOT compilation
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    SanitiseHtmlPipe,
    ArrivalStatusComponent,
    LoginComponent,
    NoBookingComponent,
    MemberBarComponent,
    FormBuilderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxSpinnerModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ModalModule,
    FormsModule,
    ReactiveFormsModule,
    FourOhFourModule,
    OnlineStatusModule,
    // FullCalendarModule,
    // NgQRCodeReaderModule,
    ZXingScannerModule,
    TranslateModule.forRoot({
      'loader': {
        'provide': TranslateLoader,
        'useFactory': HttpLoaderFactory,
        'deps': [HttpClient]
      }
    }),
    VirtualScrollerModule,
    MsalModule.forRoot(new PublicClientApplication({
      auth: {
        clientId: `${ssoClientId}`, // Application (client) ID from the app registration
        authority: `https://login.microsoftonline.com/${ssoAuthorityId}`, // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
        redirectUri: `${ssoRedirectUri}`, // This is your redirect URI
        postLogoutRedirectUri: `${ssoRedirectUri}`
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
      }
    }), {
      interactionType: InteractionType.Redirect, // MSAL Guard Configuration
      authRequest: {
        scopes: ['user.read']
      }
    }, {
      interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
      protectedResourceMap: new Map([
        ['https://graph.microsoft.com/v1.0/me', ['user.read']]
      ])
    })
  ],
  exports:[
    TranslateModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ClientTokenInterceptor, multi: true, },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    MsalGuard,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
